export const RE_ACTION_LOGIN = 'pagamentosLogin';
